import { Helmet } from 'react-helmet'
import RotatingNavigation from './RotatingNavigation'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Rotating Navigation</title>
    </Helmet>
    <RotatingNavigation />
  </>
)
export default Wrapper
